// extracted by mini-css-extract-plugin
export default {"main":"deepclean_main__E2u0P"};